import {
  Paperclip,
  Image,
  RectangleEllipsis,
  SquareSplitVertical,
  TextSelectionIcon,
  Link,
  UserRoundSearch,
  Table2Icon,
  TableIcon,
} from "lucide-react";

export default [
  {
    icon: TextSelectionIcon,
    type: "Text",
    label: "Text",
    textarea: "Text Area",
    style: {
      backgroundColor: "#ffffff",
      color: "#000000",
      padding: "10px",
      // textAlign: 'center',
      textAlign: "",
      // fontSize: '22px',
      fontSize: "",
      // fontWeight: 'normal',
      fontWeight: "",
      // textTransform: 'uppercase'//lowercase , capitilized
      textTransform: "", //lowercase , capitilized
    },
    outerStyle: {
      backgroundColor: "#ffffff",
      width: "100%",
    },
  },
  // {
  //     icon: Image,
  //     type: 'Image',
  //     label: 'Image',
  //     imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/LEGO_logo.svg/768px-LEGO_logo.svg.png?20231016092137",
  //     alt: 'Image',
  //     url: '#',
  //     style: {
  //         backgroundColor: '#ffffff',
  //         // padding: '10px',
  //         padding: '',
  //         height: '50%',
  //         // height: '',
  //         // width: '70%',
  //         width: '',
  //         margin: '0px',
  //         borderRadius: '0px'
  //     },
  //     outerStyle: {
  //         display: 'flex',
  //         width: '100%',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         backgroundColor: '#fff'
  //     }
  // },
  {
    icon: Image,
    type: "Logo",
    label: "Image",
    imageUrl:
      // "https://erpapi.eduskillsfoundation.org/email_images/0173c91a-659c-44c2-bbc8-a899f27b6ac6.png",
      "https://erpapi.eduskillsfoundation.org/email_images/c1d23cfe-f92d-4833-a96f-cec6ba0398fc.jpg",
    alt: "Image",
    url: "#",
    style: {
      backgroundColor: "#ffffff",
      padding: "10px",
      width: "30%",
      borderRadius: "",
    },
    outerStyle: {
      align: "center",
      backgroundColor: "#ffffff",
      width: "100%",
    },
  },

  {
    type: "Table",
    icon: TableIcon,
    label: "Table",
    rows: 2,
    cols: 2,
    tableStyle: {
      width: "80%",
      border: "1px solid #000",
      backgroundColor: "#ffffff",
      borderCollapse: "collapse",
      align:"center"
    },
    cells: [
      [
        { content: "1", style: { padding: "10px", border: "1px solid #9CA3AF", color: "#000000", fontSize: "14px", fontWeight: "normal", textAlign: "left", backgroundColor:"#ffffff" } },
        { content: "2", style: { padding: "10px", border: "1px solid #9CA3AF", color: "#000000", fontSize: "14px", fontWeight: "normal", textAlign: "left", backgroundColor:"#ffffff" } },
      ],
      [
        { content: "3", style: { padding: "10px", border: "1px solid #9CA3AF", color: "#000000", fontSize: "14px", fontWeight: "normal", textAlign: "left", backgroundColor:"#ffffff" } },
        { content: "4", style: { padding: "10px", border: "1px solid #9CA3AF", color: "#000000", fontSize: "14px", fontWeight: "normal", textAlign: "left", backgroundColor:"#ffffff" } },
      ],
    ],
  },
  {
    icon: RectangleEllipsis,
    label: "Button",
    type: "Button",
    content: "Sample Button",
    url: "#",

    // Button TD styles (email-safe)
    style: {
      backgroundColor: "#007bff",
      color: "#ffffff",
      padding: "10px", // email safe
      fontSize: "10px",
      borderRadius: "4px", // supported (mostly)
      fontWeight: "normal",
      width: "100px", // works on <td>
      height: "33px", // not recommended (email ignores height)
      textAlign: "center",
    },
    outerStyle: {
      align: "center", // ← replaces justifyContent
      width: "100%",
    },
  },
  // {
  //     icon: Frame,
  //     type: 'Logo',
  //     label: 'Logo',
  //     imageUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/LEGO_logo.svg/768px-LEGO_logo.svg.png?20231016092137",
  //     alt: 'logo',
  //     url: '#',
  //     style: {
  //         backgroundColor: '#ffffff',
  //         padding: '10px',
  //         height: '30%',
  //         width: '30%',
  //     },
  //     outerStyle: {
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         backgroundColor: '#fff',
  //         width: '100%'
  //     }
  // },
  // {
  //     icon: PanelTop,
  //     type: 'LogoHeader',
  //     label: 'Logo Header',
  //     imageUrl: "https://www.google.com/url?sa=i&url=https%3A%2F%2Fcommons.wikimedia.org%2Fwiki%2FFile%3ALEGO_logo.svg&psig=AOvVaw2DdcD1Sa8xYXPVnjgQp-AW&ust=1764152818358000&source=images&cd=vfe&opi=89978449&ved=0CBIQjRxqFwoTCPjP9cSLjZEDFQAAAAAdAAAAABAE",
  //     alt: 'logo',
  //     url: '#',
  //     style: {
  //         backgroundColor: '#ffffff',
  //         padding: '10px',
  //         height: '40%',
  //         width: '40%',
  //     },
  //     outerStyle: {
  //         display: 'flex',
  //         justifyContent: 'left',
  //         alignItems: 'center',
  //         backgroundColor: '#fff',
  //         width: '100%'
  //     }
  // },
  {
    icon: Link,
    type: "Url",
    label: "Url",
    urlElements: [
      {
        sidetext: "Click here :",
        url: "#",
      },
    ],
    style: {
      backgroundColor: "#ffffff",
      color: "#000000",
      padding: "10px",
      textAlign: "",
      fontSize: "10px",
      fontWeight: "",
      textTransform: "", //lowercase , capitilized
    },
    // outerStyle: {
    //   padding: "10px",
    //   backgroundColor: "#fff",
    //   textAlign: "left"
    // }
  },
  {
    icon: SquareSplitVertical,
    type: "Divider",
    label: "Divider",
    content: "",
    style: {
      color: "#dabebe", 
      padding: "10px", 
      width: "100%", 
      thickness: "1px", 
      valign: "middle", 
    },
  },
  {
    type: "SocialHandles",
    icon: UserRoundSearch,
    label: "SocialHandles",
    socialIcons: [
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/f63f4b23-c1c8-498a-b8db-241c3ee47fa9.png",
        name: "website",
        url: "#",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/6f5f5fa4-143c-4bf6-b4ae-40a383f1c5d2.png",
        name: "facebook",
        url: "#",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/fb3fed5d-f64f-4602-981f-2e171163b195.png",
        name: "instagram",
        url: "#",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/4748c57d-bbc7-4d1c-87e2-c64dd3c54bb4.png",
        name: "linkdin",
        url: "#",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/f283f9a3-5724-4794-86f6-564f0486ba58.png",
        name: "twiter",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/17faaffa-2bf0-4cfd-a45b-5bf907610e58.png",
        name: "github",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/a7903ee1-4e22-4db2-a58e-c4d5ac0b0b26.png",
        name: "figma",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/60f1db3f-720e-47c7-9a57-50e1d018078a.png",
        name: "slack",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/cfeedbde-cb2d-4c1a-86ea-b069e20bd565.png",
        name: "redit",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/51983d63-e493-4f70-9d36-410029be24bb.png",
        name: "codepen",
        url: "",
      },
      {
        iconImage:
          "https://erpapi.eduskillsfoundation.org/email_images/5c77961c-ef8e-4dd9-9f0b-c73063905137.png",
        name: "youtube",
        url: "#",
      },
    ],

    style: {
      width: "100%",
      padding: "",
      backgroundColor: "#ffffff",
      marginRight: "5px",
      marginBottom: "",
      align: "center",
    },
    outerStyle: {
      width: "30px",
    },
  },
];

// Social icons :
// Instagram : https://erpapi.eduskillsfoundation.org/email_images/fb3fed5d-f64f-4602-981f-2e171163b195.png  -
// facebook : https://erpapi.eduskillsfoundation.org/email_images/6f5f5fa4-143c-4bf6-b4ae-40a383f1c5d2.png  -
// youtube : https://erpapi.eduskillsfoundation.org/email_images/5c77961c-ef8e-4dd9-9f0b-c73063905137.png  -
// twitter : https://erpapi.eduskillsfoundation.org/email_images/f283f9a3-5724-4794-86f6-564f0486ba58.png  -
// linkdin : https://erpapi.eduskillsfoundation.org/email_images/4748c57d-bbc7-4d1c-87e2-c64dd3c54bb4.png  -
// WhatsApp : https://erpapi.eduskillsfoundation.org/email_images/e89b3bd4-f574-4d45-bdfe-22041b93389f.png
// GitHub : https://erpapi.eduskillsfoundation.org/email_images/17faaffa-2bf0-4cfd-a45b-5bf907610e58.png  -
// redit : https://erpapi.eduskillsfoundation.org/email_images/cfeedbde-cb2d-4c1a-86ea-b069e20bd565.png  -
// codepen : https://erpapi.eduskillsfoundation.org/email_images/51983d63-e493-4f70-9d36-410029be24bb.png  -
// behance : https://erpapi.eduskillsfoundation.org/email_images/dd69a684-fcf9-46bc-baa1-bb5b4cd011bc.png
// figma : https://erpapi.eduskillsfoundation.org/email_images/a7903ee1-4e22-4db2-a58e-c4d5ac0b0b26.png  -
// dribble : https://erpapi.eduskillsfoundation.org/email_images/ad0d3c9b-8ed0-4b47-be18-ecfb7c575181.png
// slack : https://erpapi.eduskillsfoundation.org/email_images/60f1db3f-720e-47c7-9a57-50e1d018078a.png  -
// more : https://erpapi.eduskillsfoundation.org/email_images/08d8691b-070b-4340-958d-cd558b528575.png
